
import {getReferrals} from '../api/getReferrals';
import {setGetReferralsAction} from '../action';

const setGetReferrals = (params) => {
    return async (dispatch, getState) => {
        try {
            const {data} = await getReferrals(params);

            if (data.status === 'success') {
                dispatch(setGetReferralsAction({
                    data: data.data,
                    countPage: data.countPage
                }));           
            }
          
        } catch(error) {
            if (error && error.response && error.response.status === 401) {
                localStorage.removeItem('token');
                window.location.replace(window.location.origin);
            }
        }
    }
}

export {
    setGetReferrals
}